import Button from 'src/components/button/Button';
import FilterSvg from 'src/components/svg/FilterSvg';

//#region [Props]
type FilterButtonProps = {
	showFilterDialog: () => void;
	text?: string;
	className?: string;
};
//#endregion

//#region [Component]
export default function FilterButton({ showFilterDialog, text, className }: FilterButtonProps) {
	return <Button title={text} inverse={!!text} className={className} onClick={showFilterDialog} text={text ?? "Filtrer"} icon={<FilterSvg />}/>
}
//#endregion
